import { Russian } from "flatpickr/dist/l10n/ru.js";
import { Uzbek } from "flatpickr/dist/l10n/uz.js";

export const UzbekLatin = {
  weekdays: {
    shorthand: ["Yak", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
    longhand: [
      "Yakshanba",
      "Dushanba",
      "Seshanba",
      "Chorshanba",
      "Payshanba",
      "Juma",
      "Shanba",
    ],
  },
  months: {
    shorthand: [
      "Yan",
      "Fev",
      "Mar",
      "Apr",
      "May",
      "Iyun",
      "Iyul",
      "Avg",
      "Sen",
      "Okt",
      "Noy",
      "Dek",
    ],
    longhand: [
      "Yanvar",
      "Fevral",
      "Mart",
      "Aprel",
      "May",
      "Iyun",
      "Iyul",
      "Avgust",
      "Sentabr",
      "Oktabr",
      "Noyabr",
      "Dekabr",
    ],
  },
  firstDayOfWeek: 1,
  ordinal: function () {
    return "";
  },
  rangeSeparator: " - ",
  weekAbbreviation: "Hf",
  scrollTitle: "Kattalashtirish uchun aylantiring",
  toggleTitle: "O'tish uchun bosing",
  amPM: ["TO", "TK"],
  yearAriaLabel: "Yil",
  monthAriaLabel: "Oy",
  hourAriaLabel: "Soat",
  minuteAriaLabel: "Daqiqa",
};

export const getFlatpickrLocale = (lang) => {
  if (lang === "uz") {
    return UzbekLatin;
  }
  if (lang === "uzc") {
    return Uzbek;
  }
  if (lang === "ru" || lang === "rs") {
    return Russian;
  }
  return undefined;
};
